//     							                          //
//  Program: LeasingSidebar.jsx                           //
//  Application: Property                                 //
//  Option: common component Leasing Sidebar              //
//  Developer: NP 		                                  //
//  Date: 2022-04-02                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { Link } from "react-router-dom";
// import { Dropdown } from 'react-bootstrap';
class BrandSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathname: window.location.pathname,
      property_slug: sessionStorage.getItem("property_slug")
        ? sessionStorage.getItem("property_slug")
        : "",
      brand_slug: sessionStorage.getItem("brand_slug")
        ? sessionStorage.getItem("brand_slug")
        : "",
    };
  }

  isPathActive(path) {
    var a = document.getElementsByClassName("nav-link active");
    if (a && a[0]) {
      a[0].scrollIntoView({
        behavior: "auto",
        block: "center",
        inline: "center",
      });
    }
    return window.location.pathname.includes(path);
  }

  toggleHeaderMenu(e) {
    e.preventDefault();
    document.querySelector(".mobchildMenu").classList.toggle("d-none");
    document.querySelector("body").classList.toggle("az-header-menu-show");
  }

  toggleChildMenu(e) {
    e.preventDefault();
    const data = document.querySelector(".left");
    data.classList.replace("left", "hide");
  }

  render() {
    return (
      <>
        <div className="deskchildMenu">
          <Link to="/brands"><div
            className="backtosubMenu"
            // onClick={(event) => this.toggleChildMenu(event)}
          >
            <i className="fas fa-chevron-left"></i>Back to Brands
          </div></Link>
          <aside>
            <nav className="nav nav-pills flex-column pd-r-8">
              <ul>
                <li>
                  <ul>
                    {global.userPermissions.checkPermission("brand-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("brand-info")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/brand/view/" +
                            (this.props.brand_slug
                              ? this.props.brand_slug
                              : this.state.brand_slug) +
                            "/brand-info"
                          }
                        >
                          Overview
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "brand-cms-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("brand-legal-finance")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/brand/view/" +
                            (this.props.brand_slug
                              ? this.props.brand_slug
                              : this.state.brand_slug) +
                            "/brand-legal-finance"
                          }
                        >
                          Legal & Finance
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "brand-cms-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("brand-cms")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/brand/view/" +
                            (this.props.brand_slug
                              ? this.props.brand_slug
                              : this.state.brand_slug) +
                            "/brand-cms"
                          }
                        >
                          CMS
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
                <li>
                  <span>CRM</span>
                  <ul>
                    {global.userPermissions.checkPermission(
                      "crm-campaigns-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("crm-campaign")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/brand/view/" +
                            (this.props.brand_slug
                              ? this.props.brand_slug
                              : this.state.brand_slug) +
                            "/crm-campaign"
                          }
                        >
                          Campaign
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "crm-templates-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("crm-template") ||
                            this.isPathActive("crm-templates")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/brand/view/" +
                            (this.props.brand_slug
                              ? this.props.brand_slug
                              : this.state.brand_slug) +
                            "/crm-templates"
                          }
                        >
                          Templates
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "crm-lists-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("crm-list")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/brand/view/" +
                            (this.props.brand_slug
                              ? this.props.brand_slug
                              : this.state.brand_slug) +
                            "/crm-list"
                          }
                        >
                          Lists
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              </ul>
            </nav>
          </aside>
        </div>
        <div className="mobchildMenu">
          <div className="d-flex justify-content-between align-items-center submenu">
            <div className="newSubmenu">
              <Link to="/brands"><span
                className="back"
                // onClick={(event) => this.toggleHeaderMenu(event)}
              >
                <i className="fas fa-chevron-left"></i> Back to Brands
              </span></Link>
              <ul>
                <li>
                  <ul>
                    {global.userPermissions.checkPermission("brand-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("brand-info")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/brand/view/" +
                            (this.props.brand_slug
                              ? this.props.brand_slug
                              : this.state.brand_slug) +
                            "/brand-info"
                          }
                        >
                          Overview
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "brand-cms-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("brand-cms")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/brand/view/" +
                            (this.props.brand_slug
                              ? this.props.brand_slug
                              : this.state.brand_slug) +
                            "/brand-cms"
                          }
                        >
                          CMS
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
                <li>
                  <span>CRM</span>
                  <ul>
                    {global.userPermissions.checkPermission(
                      "crm-campaigns-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("crm-campaign")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/brand/view/" +
                            (this.props.brand_slug
                              ? this.props.brand_slug
                              : this.state.brand_slug) +
                            "/crm-campaign"
                          }
                        >
                          Campaign
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "crm-templates-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("crm-template") ||
                            this.isPathActive("crm-templates")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/brand/view/" +
                            (this.props.brand_slug
                              ? this.props.brand_slug
                              : this.state.brand_slug) +
                            "/crm-templates"
                          }
                        >
                          Templates
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "crm-lists-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("crm-list")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/brand/view/" +
                            (this.props.brand_slug
                              ? this.props.brand_slug
                              : this.state.brand_slug) +
                            "/crm-list"
                          }
                        >
                          Lists
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default BrandSidebar;
